import { render, staticRenderFns } from "./r-trigger-product.vue?vue&type=template&id=57bbf246&scoped=true"
import script from "./r-trigger-product.vue?vue&type=script&lang=js"
export * from "./r-trigger-product.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-product.vue?vue&type=style&index=0&id=57bbf246&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bbf246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57bbf246')) {
      api.createRecord('57bbf246', component.options)
    } else {
      api.reload('57bbf246', component.options)
    }
    module.hot.accept("./r-trigger-product.vue?vue&type=template&id=57bbf246&scoped=true", function () {
      api.rerender('57bbf246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-product.vue"
export default component.exports